import { render, staticRenderFns } from "./game-header.html?vue&type=template&id=9deec11e&scoped=true&external"
import script from "./game-header.js?vue&type=script&lang=js&external"
export * from "./game-header.js?vue&type=script&lang=js&external"
import style0 from "./game-header.css?vue&type=style&index=0&id=9deec11e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9deec11e",
  null
  
)

export default component.exports